var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFooterCompass = function SvgIcFooterCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767884",
    d: "M8 8.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#767884",
    d: "M8 1.5A6.507 6.507 0 0 0 1.5 8c0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5S11.584 1.5 8 1.5m3.283 3.542L9.818 8.704a2 2 0 0 1-1.114 1.114l-3.662 1.465a.25.25 0 0 1-.325-.325l1.465-3.662a2 2 0 0 1 1.114-1.114l3.662-1.465a.25.25 0 0 1 .325.325"
  })));
};
export default SvgIcFooterCompass;